import React, { FunctionComponent } from "react";
import { SpeakerListItemProps } from "../../interfaces/interfaces";

const SpeakerListItem: FunctionComponent<SpeakerListItemProps> = ({
  speaker,
  onClick,
}) => {
  const { name, image, title } = speaker;
  function splitTextByLastComma(text: string): { part1: string, part2: string } {
    // Find the position of the last comma
    const lastCommaIndex = text.lastIndexOf(',');
  
    // If there's no comma, return the original text as part1 and an empty string as part2
    if (lastCommaIndex === -1) {
      return { part1: text, part2: '' };
    }
  
    // Split the text into two parts
    const part1 = text.substring(0, lastCommaIndex).trim();
    const part2 = text.substring(lastCommaIndex + 1).trim();
  
    return { part1, part2 };
  }
  const { part1, part2 } = splitTextByLastComma(title);
  return (
    <div className="speakerListItem">
      <div className="speakerListItemImage" onClick={() => onClick(speaker)}>
        <img src={image} alt={name} title={name} />
      </div>
      <div className="speakerInfo">
        <div className="speakerName">{name}</div>
        <div className="speakerTitle">{part1},<br />{part2}</div>
      </div>
    </div>
  );
};

export default SpeakerListItem;
